import React from 'react';

/**
 * Aspect ratio picker — shows ratios as correctly-proportioned
 * rectangles so the user picks by shape, not by reading "4:5".
 */

interface AspectRatioVisualProps {
    slug: string;
}

const RATIO_DIMENSIONS: Record<string, { w: number; h: number }> = {
    '1:1': { w: 60, h: 60 },
    '4:5': { w: 48, h: 60 },
    '3:4': { w: 45, h: 60 },
    '9:16': { w: 34, h: 60 },
    '16:9': { w: 60, h: 34 },
};

export const AspectRatioVisual: React.FC<AspectRatioVisualProps> = ({ slug }) => {
    const d = RATIO_DIMENSIONS[slug] || RATIO_DIMENSIONS['1:1'];
    return (
        <div
            style={{
                width: '100%',
                height: 70,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    width: d.w,
                    height: d.h,
                    border: '1.5px solid currentColor',
                    borderRadius: 4,
                    background: 'currentColor',
                    opacity: 0.12,
                    boxShadow: 'inset 0 0 0 1.5px currentColor',
                }}
            />
        </div>
    );
};
